<template>
    <v-slide-y-transition hide-on-leave>
        <List v-if="show" :key="key" class="siteListContainer">
            <transition name="fade" mode="out-in">
                <div v-if="this.$store.state.display.loadingSites"
                     class="d-flex justify-center align-center flex-column"
                     style="height:100%">
                    <v-progress-circular :size="50" :width="2"
                                         :color="ada.pink" indeterminate>
                    </v-progress-circular>
                    <div class="mt-4 text-center" :style="{color: ada.darkGrey}">Seiten werden geladen...</div>
                </div>
                <div v-else style="height:100%">
                    <div v-for="(publisher, i) in sites" :key="'publisher_'+i" class="publisherContainer">
                        <span class="publisherName">{{ publisher.Name }}</span>
                        <div class="itemContainer pa-2">
                            <v-list-item v-for="(site, j) in publisher.sites" :key="'site_'+j"
                                         :class="active(site)" @click="$emit('input', site)">
                                <!--            <v-list-item-icon title="Zone löschen" v-if="!readOnly">
                                                <v-icon :color="ada.grey" right @click.stop="deleteZone(item)">mdi-delete</v-icon>
                                            </v-list-item-icon>-->
                                <v-list-item-icon class="my-auto" style="margin-right: 10px;"
                                                  v-if="typeof items === 'undefined' && $route.name !== 'video'">
                                    <v-tooltip top v-if="getColor(site.StatusName) !== 'green'">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" small :color="getColor(site.StatusName)">
                                                mdi-checkbox-blank-circle
                                            </v-icon>
                                        </template>
                                        <span>{{
                                                getColor(site.StatusName) === 'orange' ? 'Seite teilweise deaktiviert' : 'Seite deaktiviert'
                                            }}</span>
                                    </v-tooltip>
                                    <v-icon v-else :color="getColor(site.StatusName)" small>
                                        mdi-checkbox-blank-circle
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="font-weight-regular">{{ site.Name }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </div>
                    </div>
                    <div v-if="sites.length === 0 && !this.$store.state.display.loadingSites"
                         class="d-flex justify-center align-center" :style="{height:'100%', color: ada.darkGrey}">Keine
                        Seiten
                        verfügbar
                    </div>
                </div>
            </transition>
        </List>
    </v-slide-y-transition>
</template>

<script>
import ada from '@/scss/ada_colors.scss'
import List from "../../components/List";

export default {
    name: "SitesList",
    props: {
        value: {},
        show: Boolean,
        items: Array,
        store: {
            default: 'display'
        },
        type: {
            type: String,
            default: 'display',
            validator: function (value) {
                // The value must match one of these strings
                return ['display', 'video'].includes(value);
            }
        }
    },
    components: {List},
    data: () => {
        return {
            key: 0,
            ada,
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        selectedPublisher() {
            return this.$store.state[this.store].selectedPublisher;
        },
        publisher_sites() {
            let ret = [];
            let ogSites = this.type === 'video' ? this.$store.state.video.sites : this.vuexState.sites;
            ogSites.forEach((site) => {
                let sitesPublisher = JSON.parse(JSON.stringify(this.vuexState.publisher.find(x => x.PublisherId === site.PublisherId)));
                let sitesDeviceTypes = JSON.parse(site.hasTypes);
                if ((this.selectedPublisher.length === 0 || this.selectedPublisher.find(x => x.PublisherId === sitesPublisher.PublisherId)) && (this.type === 'video' || sitesDeviceTypes.some(r => this.vuexState.device_types.includes(r)))) {
                    let ret_publisher = ret.find(x => x.PublisherId === sitesPublisher.PublisherId);
                    if (ret_publisher) {
                        ret_publisher.sites.push(site);
                    } else {
                        sitesPublisher.sites = [site]
                        ret.push(sitesPublisher);
                    }
                }
            });
            return ret;
        },
        sites() {
            if (this.items) {
                return this.items;
            } else {
                return this.publisher_sites;
            }
        },
    },
    methods: {
        active(item) {
            if (this.value &&
                ((typeof this.value.SiteId !== "undefined" && this.value.SiteId === item.SiteId) ||
                    (typeof this.value.Name !== "undefined" && this.value.Name === item.Name))
            ) {
                return 'active';
            } else {
                return ''
            }
        },
        getColor(name) {
            if (name.indexOf('color-green-red') !== -1) {
                return 'orange';
            } else if (name.indexOf('color-green') !== -1) {
                return 'green';
            } else if (name.indexOf('color-red') !== -1) {
                return 'red';
            }
        },
    },
    watch: {
        sites() {
            this.key++;
        }
    }
}
</script>

<style lang="scss" scoped>

.itemContainer {
    display: flex;
    align-items: center;
    width: 100%;
    flex-flow: column;

    .v-list-item {
        width: 100%;
    }

    &.active {
        color: #f5f5f5 !Important;
        background-color: $ada_darkGrey !important;
    }
}

.siteListContainer {
    height: 100%;
    padding: 0;
}


.publisherName {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-transform: uppercase;
    font-size: smaller;
    font-weight: 500;
    font-family: 'Montserrat', sans-serif;
    position: sticky;
    top: 0;
    background-color: #F2F5F6FF;
    height: 55px;
    z-index: 1;
    border-top: 5px solid #fff;

    &:after {
        content: '';
        background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 0.8) 100%);
        height: 10px;
        width: 100%;
        position: absolute;
        bottom: -10px;
        padding: 0;
    }
}

.siteListContainer .publisherContainer {
    &:first-child {
        margin-top: 0 !important;

        .publisherName {
            padding-top: 0;
            margin-top: 0 !important;
        }
    }
}
</style>